export const viewInvoiceData = {
  billNo: '1453654225',
  patientId: null as number | null,
  services: [
    {
      date: '24/08/2024',
      code: '12635',
      service: 'Consultation (Covered by Primary)',
      package: 'IVF- 1',
      provider: 'Dr. Alex Mokulj',
      charges: 100,
      concessionAmt: 10,
      concessionPercent: 10,
      taxAmt: 5,
      taxPercent: 5,
      netAmt: 75,
      refundStatus: 'success' as const,
    },
    {
      date: '24/08/2024',
      code: '12635',
      service: 'Consultation (Covered by Primary)',
      package: 'IVF- 1',
      provider: 'Dr. Alex Mokulj',
      charges: 100,
      concessionAmt: 10,
      concessionPercent: 10,
      taxAmt: 5,
      taxPercent: 5,
      netAmt: 75,
      refundStatus: 'success' as const,
    },
    {
      date: '24/08/2024',
      code: '12635',
      service: 'Consultation (Covered by Primary)',
      package: 'IVF- 1',
      provider: 'Dr. Alex Mokulj',
      charges: 100,
      concessionAmt: 10,
      concessionPercent: 10,
      taxAmt: 5,
      taxPercent: 5,
      netAmt: 75,
      refundStatus: 'success' as const,
    },
  ],
  totals: {
    totalAmount: 200,
    concessionAmount: 20,
    taxAmount: 10,
    netAmount: 150,
  },
  meta: {
    concessionReason: 'Employee Benefit',
    dueDate: '30/08/2025',
    termsAndConditions:
      'Payments Can Be Made Via Cash, UPI, Card, Net Banking, Or Bank Transfer. Full Payment Is Due At The Time Of Service Unless A Credit Facility Is Approved. Refunds, If Applicable, Will Be Processed Within 7–10 Working Days.',
    legalMentions:
      'Medical Services May Be Tax-Exempt Under Applicable Laws. Patient Details Are Confidential And Protected Under Privacy Regulations. All Billing Disputes Must Be Reported Within 7 Days Of Invoice Generation.',
    remark: 'Concession Applied As Per Hospital Employee Welfare Policy.',
    comments: '',
  },
};
